var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container content-area"},[_c('h1',{staticClass:"title is-hidden"},[_vm._v("Page")]),_vm._v(" "),_vm._l((_vm.site_data.rows),function(row,i){return _c('ContentRow',{key:i,attrs:{"is_mobile":_vm.is_mobile,"row":row}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13d855fd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Page.vue
// module id = null
// module chunks = 